import { render, staticRenderFns } from "./history-compact.vue?vue&type=template&id=09e6ca40&scoped=true&"
import script from "./history-compact.vue?vue&type=script&lang=js&"
export * from "./history-compact.vue?vue&type=script&lang=js&"
import style0 from "./history-compact.vue?vue&type=style&index=0&id=09e6ca40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6ca40",
  null
  
)

export default component.exports